// extracted by mini-css-extract-plugin
export default {"button":"NewArrivals_button__FPJqy"};